module.exports = __webpack_public_path__ + "static/media/atom-trapping.bbf91830.png";